import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    showPoweredBy: false,
    logo: {
      src: { light: "/logo-light.png", dark: "/logo-dark.png" },
      alt: "Fintely",
      width: "36px",
      height: "36px",
      href: "/",
    },
  },
  metadata: {
    title: "Fintely - Documentação",
    favicon: "/favicon.ico",
  },
  navigation: [
    {
      type: "category",
      label: "Documentação",
      items: [
        {
          type: "category",
          label: "Primeiros Passos",
          icon: "sparkles",
          items: [
            "/docs",
            "/authentication",
            "/security",
            "/errors",
            "/webhooks",
            "/support",
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "New",
                color: "purple",
              },
              label: "Referência da API",
              to: "/api",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "Referência da API",
    },
  ],
  // redirects: [{ from: "/", to: "/docs" }],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.json",
      path: "/api",
    },
  ],
};

export default config;
